const widgetProps = function () {
    if (typeof document !== 'undefined' && document.getElementById('housing-finder')) {
        let widgetProps = {};
        [...document.getElementById('housing-finder').attributes].forEach((attribute) => {
            widgetProps[attribute.nodeName] = attribute.nodeValue;
        });
        widgetProps.location_type_id = 0;
        switch (widgetProps?.location_type) {
            case 'college':
                widgetProps.location_type_id = 1;
                break;
            case 'state':
                widgetProps.location_type_id = 2;
                break;
            case 'city':
                widgetProps.location_type_id = 3;
                break;
        }
        delete widgetProps.id;
        delete widgetProps.class;
        return widgetProps;
    } else {
        return null;
    }
};

export default widgetProps;
